module.exports = __webpack_public_path__ + "img/ic-home-zhuanzhang.f739.be0ff606.png";